import { render } from "./TkRightDrawer.vue?vue&type=template&id=5143ffca&scoped=true"
import script from "./TkRightDrawer.vue?vue&type=script&lang=js"
export * from "./TkRightDrawer.vue?vue&type=script&lang=js"

import "./TkRightDrawer.vue?vue&type=style&index=0&id=5143ffca&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5143ffca"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QSeparator,QCardActions});
